import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { NotFoundError } from 'commons/errors'
import { Request } from 'commons/utils/request'

import { CustomerVendorsSchema } from './schema'

export const customerVendorRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: '$id',
    component: lazyRouteComponent(() => import('./CustomerVendor')),
    validateSearch: (search) => CustomerVendorsSchema.parse(search),
    beforeLoad: ({ params }) => {
      if ('id' in params && params.id && Number(params.id)) return { id: Number(params.id) }
      else throw new NotFoundError()
    },
    loaderDeps: ({ search }) => ({
      search
    }),
    loader: ({ context: { id }, deps }) => Request.post(Request.urls.bank.customerVendorDetails, { id, ...deps.search })
  })
